<!-- Admin-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Generate Activation Codes</cs-header-title>
</cs-header>

<cs-content>
  @if (!key) {
    <cs-item-list>
      <cs-item-list-header>Select role for the user:</cs-item-list-header>
      <cs-radio-group [(selected)]="role" (selectedChange)="roleChanged()">
        @for (d of authRoleDescriptions; track d) {
          @if (d.value != 0) {
            <cs-radio [value]="d.value">
              {{ d.name }}
              <cs-note>{{ d.adminExplanation }}</cs-note>
            </cs-radio>
          }
        }
      </cs-radio-group>
      <cs-item>
        <cs-label>Test key</cs-label>
        <cs-checkbox item-right [(checked)]="testKey"></cs-checkbox>
      </cs-item>
      @if (role===AuthRole.Paid) {
        <cs-item>
          <cs-label>Valid From</cs-label>
          <input-calendar [(date)]="validFrom" item-right></input-calendar>
        </cs-item>
      }
      @if (role===AuthRole.Paid) {
        <cs-item>
          <cs-label>Valid Until</cs-label>
          <input-calendar [(date)]="validUntil" item-right></input-calendar>
        </cs-item>
      }
    </cs-item-list>
  }

  @if (key!='') {
    <cs-item-list>
      <cs-item>
        <cs-label>Key</cs-label>
        <cs-input item-right [(value)]="key" [readonly]="true"></cs-input>
      </cs-item>
    </cs-item-list>
  }
</cs-content>

<cs-page-action-buttons>
  @if (key=='') {
    <cs-button primary medium [disabled]="!role" (click)="handleGenerateKey()" [label]="'Generate Key' | untranslated"></cs-button>
  }
  @if (key!='') {
    <cs-button secondary medium (click)="reset()" [label]="'Generate More' | untranslated"></cs-button>
  }
</cs-page-action-buttons>